import { getPartnerDetailsResult } from '@homeserve/od-typings/api';

export function getDefaultLanguage(partner: getPartnerDetailsResult) {
  const browserDefaultLanguage = navigator.language.substring(0, 2);
  const localeList: string[] = partner.languageDefault;

  const languageList = localeList.map(locale => locale.substring(0, 2));

  if (languageList.includes(browserDefaultLanguage)) {
    return browserDefaultLanguage;
  }

  return languageList[0];
}
